export const menuHeightSmall = '80px';
export const menuHeightBig = '180px';
